export const ViewLevel = {
    GoalsAndObjectives: 0,
    KeyResults: 1,
    Tasks: 2
}